import { render, staticRenderFns } from "./RegionSelect.vue?vue&type=template&id=1dc70dea&scoped=true"
import script from "./RegionSelect.vue?vue&type=script&lang=js"
export * from "./RegionSelect.vue?vue&type=script&lang=js"
import style0 from "./RegionSelect.vue?vue&type=style&index=0&id=1dc70dea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc70dea",
  null
  
)

export default component.exports